import UserChangePasswordForm from "./user-change-password-form";

export default UserChangePasswordForm;